// extracted by mini-css-extract-plugin
export var actions = "_10-0";
export var actionsContainer = "_10-6";
export var border = "_10-1";
export var childFullHeight = "_10-d";
export var collapse = "_10-2";
export var content = "_10-8";
export var contentChild = "_10-c";
export var fullscreen = "_10-a";
export var headerContainer = "_10-3";
export var headerRow = "_10-5";
export var hidePadding = "_10-9";
export var noScrollX = "_10-e";
export var noScrollY = "_10-f";
export var optOutTopPadding = "_10-b";
export var pagePadding = "_10-7";
export var profile = "_10-g";
export var profileContainer = "_10-h";
export var profileImage = "_10-i";
export var profileMain = "_10-j";
export var profileSubtitle = "_10-l";
export var profileTitle = "_10-k";
export var tabsWrapper = "_10-4";
export var title = "_10-m";